// Profile timestamps and displayed dates use UTC. Both date limits include the full day.
export const profileDateRange = (from, to) => ({
    from: from ? Date.parse(`${from}T00:00:00Z`) / 1000 : -Infinity,
    to: to ? Date.parse(`${to}T23:59:59.999Z`) / 1000 : Infinity,
});

export const filterProfileCampaigns = (campaigns, {campaignType = '', filterText = '', from = '', to = ''} = {}) => {
    const query = filterText.trim().toLowerCase();
    const range = profileDateRange(from, to);
    if (range.from > range.to) return [];
    return campaigns.filter(campaign => {
        if (query && ![campaign.id, campaign.name, campaign.campaignType].some(
            value => typeof value === 'string' && value.toLowerCase().includes(query)
        )) return false;
        if (campaignType && campaign.campaignType !== campaignType) return false;
        if (!from && !to) return true;
        const start = Number(campaign.start);
        const end = Number(campaign.end);
        return Number.isFinite(start) && Number.isFinite(end) && start <= range.to && end >= range.from;
    });
};
